import React, { useRef, useState } from 'react'
import constants from '../../Constants/constants';
import { Button, Col, Form, Input, Modal, Row, Spin, Typography, Upload } from 'antd';
import { DownloadOutlined, CloseOutlined, UploadOutlined } from '@ant-design/icons';
import { handleFileUploadChanges } from '../../GlobalFunctions/GlobalFunctions';

const { TextArea } = Input
const { Paragraph } = Typography

const customRequest = ({ _, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

const ContactUs = (props) => {
  const {
    openModal,
    setOpenModal,
    downloadRole,
    form,
    loading,
    handleDownload,
    handleQuerySubmit,
  } = props

  const warningShown = useRef(false);
  const [fileList, setFileList] = useState([]);
  const userRoleText = constants.UserRolesArray.find((item) => downloadRole === item?.value)?.main

  const handleFileUpload = (fileList) => {
    let supportedFormats = ['image/jpg', 'image/jpeg', 'image/png']
    let validFiles = handleFileUploadChanges(
      fileList,
      supportedFormats,
      warningShown,
    )
    setFileList(validFiles)
  }

  const fileValidationTooltip = (
    <Col span={24}>
      <span className='mail-detail'>{constants.ValidImages}</span>
    </Col>
  )

  const checkEmptySpace = (e) => {
    const value = e.target.value;
    if (/^[\s\n]/.test(value)) {
      form.setFieldsValue({
        queries: value.replace(/^[\s\n]+/, '')
      });
    }
  };

  return (
    <Modal
      centered
      destroyOnClose
      title={constants.ContactUs}
      open={openModal}
      width={800}
      footer={null}
      maskClosable={false}
      closeIcon={
        <Button
          disabled={loading}
          icon={<CloseOutlined />}
          type='text'
          onClick={() => {
            form.resetFields()
            setOpenModal(false)
          }}
        />
      }
    >
      <Spin spinning={loading}>
        <div className='m-auto pb-2'>
          <div style={{ textAlign: "center" }}>
            <Paragraph className='font-bold'>
              To help navigating the system with ease, download the {userRoleText?.toLowerCase()} manual here.
            </Paragraph>
            <Button
              onClick={handleDownload}
              type="primary"
              icon={<DownloadOutlined />}
            >
              {userRoleText} Manual
            </Button>
          </div>
        </div>
        <div className='m-auto p-2'>
          <div className='font-bold text-sm pb-4'>{constants.ContactUsMessage}</div>
          <Form form={form} layout="vertical" onFinish={handleQuerySubmit}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label={constants.Name}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="email"
                  label={constants.Email}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              name="queries"
              label={constants.Queries}
              rules={[{ required: true, message: "Please enter your queries." }]}
            >
              <TextArea onChange={checkEmptySpace} rows={3} placeholder={constants.Queries} />
            </Form.Item>
            <Form.Item
              name='attachments'
              label={constants.Attachments}
              tooltip={fileValidationTooltip}
            >
              <Upload
                customRequest={customRequest}
                multiple={true}
                onChange={({ fileList }) => handleFileUpload(fileList)}
                className='p-0'
                fileList={fileList}
              >
                <Button icon={<UploadOutlined />}>{constants.ChooseFiles}</Button>
              </Upload>
            </Form.Item>
            <Form.Item className='text-right'>
              <Button type="primary" htmlType="submit">
                {constants.Send}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Spin>
    </Modal>
  );
}

export default ContactUs;